import userLogin from '@/views/userLogin.vue';
import helpVue from '@/views/helpVue.vue';
import redditTranslate from '@/views/redditTranslate.vue';


import { createRouter, createWebHistory } from 'vue-router'

/* --- 视图组件 --- */




/* --- 路由表 --- */
const routes = [
{ path: '/', component: userLogin },
{ path: '/help', component: helpVue },
{ path: '/reddit-translate', component: redditTranslate },
  

 
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL), // uris without hashes #, see https://router.vuejs.org/guide/essentials/history-mode.html#html5-history-mode
    routes
});
router.beforeEach((to, from, next) => {
     next(); 
});

/* --- 全局前置守卫 --- */
router.beforeEach((to, from, next) => {
//  const token = localStorage.getItem('access_token')

//   // 1. 白名单：这些路径不用 token 也能进
//   const whiteList = ['/userLogin', '/userManager', '/userManagerPage']   // 按需加
//   if (whiteList.includes(to.path)) {
//     return next()          // 直接放行，别再 redirect
//   }

//   // 2. 其他页面才需要 token
//   if (!token) {
//     return next('/userLogin' )
//   }

  next() // 有 token 正常通过
})

export default router